<section class="py-5">
  <div class="wallet-container">
    <h2 class="wallet-title mb-3">
      <span class="material-icons-outlined">account_balance_wallet</span>
      Your Wallet
    </h2>

    <div class="balance-box">
      <p class="label">Current Balance</p>
      <h3 class="balance">${{ balance }}</h3>
    </div>

    <div class="add-money-box">
     <div class="row g-3 align-items-center justify-content-center mb-4">
  <div class="col-12 col-sm-6 col-md-6 pr-0">
    <input
      type="number"
      class="form-control"
      [(ngModel)]="amountToAdd"
      placeholder="Enter amount"
      min="1"
    />
  </div>
  <div class="col-auto pl-1">
    <button
      type="button"
      class="btn btn-success"
      (click)="showStripeForm = true"
    >
      Add Money
    </button>
  </div>
</div>


    </div>

    <!-- Stripe Payment Form Section -->
    <div *ngIf="showStripeForm" class="stripe-form-wrapper">

      <form (ngSubmit)="onStripeSubmit()" #stripeForm="ngForm">
        <div id="card-element" style="padding: 10px; border: 1px solid #ccc; border-radius: 4px;"></div>


        <div style="margin-top: 15px;">
          <button type="submit">Pay ${{ amountToAdd }}</button>
        </div>
      </form>
    </div>
  </div>
</section>
